class upsellProduct extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("upsell-product .price_box_img").forEach((item) => {
      item.addEventListener("click", this.onSummaryClick.bind(this));
    });
  }
  onSummaryClick(event, selectItemPrice) {
    const element = event.currentTarget;
    var element_price = parseInt(element.getAttribute("upsell-product-price"));
    var element_product_id = element.getAttribute("upsell-product-id");
    var element_upsell_var_id = element.getAttribute("upsell-var-id");
    var element_upsell_product_title = element.getAttribute(
      "upsell-product-title"
    );
    var element_upsell_item_qty = parseInt(
      element.getAttribute("data-upsell-item-qty")
    );
    var totalt_product_and_upsell_product_price = parseInt(
      document.querySelector("#button_total_price").innerHTML
    );
    console.log(element);
    console.log(
      `element_upsell_var_id = ${element_upsell_var_id}, element_product_id = ${element_product_id}--${element_upsell_product_title},element_upsell_item_qty = ${element_upsell_item_qty} `
    );
    var Bundle_ID = document
      .querySelector("#bundle_properties_wrap")
      .getAttribute("now");
    const detailsElement = element.parentNode;

    if (detailsElement.classList.contains("active")) {
      console.log("if");
      var selectItemPrice = parseInt(
        document.querySelector("input#temp_price").value
      );
      detailsElement.classList.remove("active");
      selectItemPrice = selectItemPrice - element_price;
      document
        .querySelector("#main_product_bundle_id")
        .setAttribute("disabled", "disabled");
      document.querySelector("input#temp_price").value = selectItemPrice;

      var selected_items = parseInt(
        document
          .querySelector("input#temp_price")
          .getAttribute("selected_items")
      );
      selected_items = selected_items - 1;
      document
        .querySelector("input#temp_price")
        .setAttribute("selected_items", selected_items);
      document.querySelector(
        ".add_on_count"
      ).innerHTML = `<span>${selected_items}</span> add-ons selected`;
      if (selected_items == 0) {
        document.querySelector(".add_on_count").innerHTML = "";
      }
      // custom added start
      var element_upsell_total_item_qty = parseInt(
        element.getAttribute("data-upsell-total-item-qty")
      );
      element.setAttribute(
        "data-upsell-total-price",
        element_upsell_total_item_qty * element_price
      );
      document
        .querySelector("input#temp_price")
        .setAttribute(
          "total-individual-item-price",
          element_upsell_total_item_qty * element_price
        );
      var allTotalPrice = 0;
      var active_upsell_items = document.querySelectorAll(
        "upsell-product.active"
      );
      console.log(active_upsell_items);
      active_upsell_items.forEach((active_upsell_item) => {
        var individualItemTotalPrice = active_upsell_item
          .querySelector(".price_box_img")
          .getAttribute("data-upsell-total-price");
        console.log(`individualItemTotalPrice = ${individualItemTotalPrice}`);
        allTotalPrice = allTotalPrice + parseInt(individualItemTotalPrice);
      });
      console.log(`allTotalPrice = ${allTotalPrice}`);
      console.log(
        `totalt_product_and_upsell_product_price = ${totalt_product_and_upsell_product_price},selectItemPrice= ${selectItemPrice}, allTotalPrice = ${allTotalPrice} `
      );
      var final_product_upsell_price = Shopify.formatMoney(
        totalt_product_and_upsell_product_price + allTotalPrice,
        money_format
      );
      // custom added end
      // var final_product_upsell_price =  Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice, money_format);
      document.querySelector(".button-total-price").innerHTML =
        final_product_upsell_price;
      document
        .querySelector(".button-total-price")
        .setAttribute(
          "product-price",
          totalt_product_and_upsell_product_price + allTotalPrice
        );
      document
        .querySelector(`#upsell_var_ids [value="${element_upsell_var_id}"]`)
        .remove();
      document
        .querySelector(`#upsell_var_ids .qty_${element_upsell_var_id}`)
        .remove();
      document
        .querySelector(`#upsell_var_ids .properties_${element_upsell_var_id}`)
        .remove();
    } else {
      console.log("else");
      var selectItemPrice = parseInt(
        document.querySelector("input#temp_price").value
      );
      detailsElement.classList.add("active");
      selectItemPrice = selectItemPrice + element_price;
      document.querySelector("input#temp_price").value = selectItemPrice;
      document
        .querySelector("#main_product_bundle_id")
        .removeAttribute("disabled");

      var selected_items = parseInt(
        document
          .querySelector("input#temp_price")
          .getAttribute("selected_items")
      );
      selected_items = selected_items + 1;
      document
        .querySelector("input#temp_price")
        .setAttribute("selected_items", selected_items);
      document.querySelector(
        ".add_on_count"
      ).innerHTML = `<span>${selected_items}</span> add-ons selected`;

      // Shopify.formatMoney(2000, money_format)
      // custom added start
      var element_upsell_total_item_qty = parseInt(
        element.getAttribute("data-upsell-total-item-qty")
      );
      element.setAttribute(
        "data-upsell-total-price",
        element_upsell_total_item_qty * element_price
      );
      document
        .querySelector("input#temp_price")
        .setAttribute(
          "total-individual-item-price",
          element_upsell_total_item_qty * element_price
        );
      var allTotalPrice = 0;
      var active_upsell_items = document.querySelectorAll(
        "upsell-product.active"
      );
      console.log(active_upsell_items);
      active_upsell_items.forEach((active_upsell_item) => {
        var individualItemTotalPrice = active_upsell_item
          .querySelector(".price_box_img")
          .getAttribute("data-upsell-total-price");
        console.log(`individualItemTotalPrice = ${individualItemTotalPrice}`);
        allTotalPrice = allTotalPrice + parseInt(individualItemTotalPrice);
      });
      console.log(`allTotalPrice = ${allTotalPrice}`);
      console.log(
        `totalt_product_and_upsell_product_price = ${totalt_product_and_upsell_product_price},selectItemPrice= ${selectItemPrice}, allTotalPrice = ${allTotalPrice} `
      );
      var final_product_upsell_price = Shopify.formatMoney(
        totalt_product_and_upsell_product_price + allTotalPrice,
        money_format
      );
      // custom added end
      // var final_product_upsell_price = Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice  , money_format); //previous code
      document.querySelector(".button-total-price").innerHTML =
        final_product_upsell_price;
      document
        .querySelector(".button-total-price")
        .setAttribute(
          "product-price",
          totalt_product_and_upsell_product_price + allTotalPrice
        );
      document.querySelector(
        "#upsell_var_ids"
      ).innerHTML += `<input type="hidden" name="items[][id]" value="${element_upsell_var_id}" class="product-upsell-id">`;
      document.querySelector(
        "#upsell_var_ids"
      ).innerHTML += `<input type="hidden" name="items[][quantity]" value="${element_upsell_item_qty}" class="product-upsell-id qty_${element_upsell_var_id}">`;
      document.querySelector(
        "#upsell_var_ids"
      ).innerHTML += `<input type="hidden" name="items[][properties][Bundle_ID]" value="${Bundle_ID}" class="product-upsell-id properties_${element_upsell_var_id}">`;
    }
  }
}

customElements.define("upsell-product", upsellProduct);

class upsellQtyInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    console.log(
      this.parentNode.previousElementSibling.previousElementSibling
        .previousElementSibling.previousElementSibling
    );
    const value = parseInt(this.input.value);
    var variant_id = this.getAttribute("data-variantid");
    document.querySelector(`.qty_${variant_id}`).value = value;
    this.parentNode.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.setAttribute(
      "data-upsell-item-qty",
      value
    );
    let productPrice =
      this.parentNode.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.getAttribute(
        "upsell-product-price"
      );
    let moneyToBeAdded = value * productPrice;
    this.parentNode.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.setAttribute(
      "data-upsell-total-price",
      moneyToBeAdded
    );

    this.parentNode.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.setAttribute(
      "data-upsell-total-item-qty",
      value
    );
    console.log("money to be added", moneyToBeAdded);

    document
      .querySelector("input#temp_price")
      .setAttribute("total-individual-item-price", value * productPrice);
    // custom add
    var allTotalPrice = 0;
    var active_upsell_items = document.querySelectorAll(
      "upsell-product.active"
    );
    console.log(active_upsell_items);
    active_upsell_items.forEach((active_upsell_item) => {
      var individualItemTotalPrice = active_upsell_item
        .querySelector(".price_box_img")
        .getAttribute("data-upsell-total-price");
      console.log(`individualItemTotalPrice = ${individualItemTotalPrice}`);
      allTotalPrice = allTotalPrice + parseInt(individualItemTotalPrice);
    });
    var totalt_product_and_upsell_product_price = parseInt(
      document.querySelector("#button_total_price").innerHTML
    );
    console.log(`allTotalPrice = ${allTotalPrice}`);
    var final_product_upsell_price = Shopify.formatMoney(
      totalt_product_and_upsell_product_price + allTotalPrice,
      money_format
    );
    // custom added end
    // var final_product_upsell_price = Shopify.formatMoney(totalt_product_and_upsell_product_price + selectItemPrice  , money_format); //previous code
    document.querySelector(".button-total-price").innerHTML =
      final_product_upsell_price;
    document
      .querySelector(".button-total-price")
      .setAttribute(
        "product-price",
        totalt_product_and_upsell_product_price + allTotalPrice
      );

    if (this.input.min == this.input.value) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', value <= min);
      // console.log('min-value = '+value);
      this.parentNode.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.click();
    }
    if (this.input.max == this.input.value) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      // buttonPlus.classList.toggle('disabled', value >= max);
      // console.log('max-value = '+value);
    }
  }
}
customElements.define("upsell-qty-input", upsellQtyInput);
